/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AlertsPage_allWarnings$ref = any;
export type AlertsPagePaginationQueryVariables = {|
  count?: ?number,
  cursor?: ?string,
  slugName?: ?string,
|};
export type AlertsPagePaginationQueryResponse = {|
  +$fragmentRefs: AlertsPage_allWarnings$ref
|};
export type AlertsPagePaginationQuery = {|
  variables: AlertsPagePaginationQueryVariables,
  response: AlertsPagePaginationQueryResponse,
|};
*/


/*
query AlertsPagePaginationQuery(
  $count: Int
  $cursor: String
  $slugName: String
) {
  ...AlertsPage_allWarnings_A0TA8
}

fragment AlertsPage_allWarnings_A0TA8 on Query {
  allWarnings(slugName: $slugName, first: $count, after: $cursor) {
    totalCount
    edges {
      node {
        id
        slugName
        description
        icon
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slugName",
    "type": "String"
  }
],
v1 = {
  "kind": "Variable",
  "name": "slugName",
  "variableName": "slugName"
},
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v1/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AlertsPagePaginationQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v1/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "AlertsPage_allWarnings"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AlertsPagePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "WarningNodeConnection",
        "kind": "LinkedField",
        "name": "allWarnings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WarningNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "WarningNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slugName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "icon",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": [
          "slugName"
        ],
        "handle": "connection",
        "key": "Alerts_allWarnings",
        "kind": "LinkedHandle",
        "name": "allWarnings"
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "AlertsPagePaginationQuery",
    "operationKind": "query",
    "text": "query AlertsPagePaginationQuery(\n  $count: Int\n  $cursor: String\n  $slugName: String\n) {\n  ...AlertsPage_allWarnings_A0TA8\n}\n\nfragment AlertsPage_allWarnings_A0TA8 on Query {\n  allWarnings(slugName: $slugName, first: $count, after: $cursor) {\n    totalCount\n    edges {\n      node {\n        id\n        slugName\n        description\n        icon\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '857ac30f15a5dde9fa5666e8efe11a05';

module.exports = node;
